import Seo from "@/components/Seo";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { COMPANY } from "@/data/content";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: [
      `By accessing this website, you agree to these Terms & Conditions. If you do not agree, please do not use the website. These terms govern use of the ${COMPANY.name} website only; QA services are governed by separate service agreements.`,
    ],
  },
  {
    title: "2. Website Content",
    body: [
      "Content on this website is provided for general information about our QA and software testing services. Case studies labelled as samples are illustrative demonstrations and do not represent real client engagements or verified results.",
      "We make reasonable efforts to keep information accurate, but make no warranties about completeness or suitability for a particular purpose.",
    ],
  },
  {
    title: "3. Intellectual Property",
    body: [
      `All content, design, branding and code on this website are the property of ${COMPANY.name} unless otherwise stated. You may not reproduce or redistribute content without written permission.`,
    ],
  },
  {
    title: "4. Enquiries & Communication",
    body: [
      "Submitting the contact form does not create a client relationship or any obligation on either party. Engagements begin only after a mutually signed service agreement.",
    ],
  },
  {
    title: "5. Limitation of Liability",
    body: [
      "To the fullest extent permitted by law, we are not liable for any indirect or consequential damages arising from use of this website or reliance on its content.",
    ],
  },
  {
    title: "6. Changes to These Terms",
    body: [
      "We may update these terms from time to time. The current version will always be published on this page.",
    ],
  },
  {
    title: "7. Contact",
    body: [
      `Questions about these terms can be sent to ${COMPANY.email}.`,
    ],
  },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms & Conditions | Avirova Technologies"
        description="Terms and conditions governing use of the Avirova Technologies website."
      />
      <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44" data-testid="terms-hero">
        <div className="grid-lines absolute inset-0" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <MaskedLine delay={0.1}>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">{"// Legal"}</p>
          </MaskedLine>
          <h1 className="mt-6 font-display text-5xl font-black tracking-tighter text-zinc-100 sm:text-6xl">
            <MaskedLine delay={0.2}>Terms &amp; Conditions</MaskedLine>
          </h1>
          <MaskedLine delay={0.34}>
            <p className="mt-5 font-mono text-xs tracking-wide text-zinc-500">
              Effective date: [Effective Date] · Last updated: [Update Date]
            </p>
          </MaskedLine>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-5 pb-24 sm:px-8 lg:pb-32" data-testid="terms-content">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <div className="border-t border-zinc-800/80 py-10">
              <h2 className="font-display text-2xl font-bold tracking-tight text-zinc-100">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-4 text-sm leading-relaxed text-zinc-400 sm:text-base">{p}</p>
              ))}
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
